<template>
  <div class="swiper">
    <div class="swiper-item" v-for="(item, i) in datas" :key="i" :class="getImgClass(i)"
         :ref='"img"+i'>
      <img :src="item.path" alt/>
    </div>
    <div class="swiper-prev" @click.stop="transPrev">
    </div>
    <div class="swiper-next" @click.stop="transNext">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImgSwiperV3',
  props: {
    datas: { //数据源（必填）
      type: Array,
      default: () => {
        return [];
      },
    },
    interval: { //轮播间隔（单位：ms）
      type: Number,
      default: () => {
        return 3000;
      },
    },
    animationInterval: { //轮播执行动画间隔（单位：ms）
      type: Number,
      default: () => {
        return 400;
      },
    },
    moveDistance: { //需触发轮播的鼠标移动x轴最小距离（单位：px）
      type: Number,
      default: () => {
        return 100;
      },
    },
  },
  data() {
    return {
      oldCurrentIndex: -1,
      currIndex: 0,
      transing: false,
      rem: 100,
    };
  },
  mounted() {
    this.rem = document.documentElement.style.fontSize.replace('px', '') * 1;
    this.resetItemPosition();
    this.refreshInterval();
  },
  unmounted() {
    clearInterval(this.intervalFun);
  },
  watch: {
    currIndex(newVal) {
      if (this.transing) {
        return;
      }
      this.transing = true;
      this.resetItemPosition();
      setTimeout(() => {
        this.transClear();
      }, this.animationInterval);
    },
  },
  methods: {
    transPrev() {
      this.currIndex = this.getPrevIndex(this.currIndex);
      this.refreshInterval();
    },
    transNext() {
      this.currIndex = this.getNextIndex(this.currIndex);
      this.refreshInterval();
    },
    transIndex(i) {
      if (this.transing) {
        return;
      }
      this.currIndex = i;
      this.refreshInterval();
    },
    /**
     刷新定时器
     @param
     @return
     */
    refreshInterval() {
      clearInterval(this.intervalFun);
      this.intervalFun = setInterval(() => {
        this.currIndex = this.getNextIndex(this.currIndex);
      }, this.interval);
    },

    resetItemPosition() {
      this.datas.forEach((item, index) => {
        let translate = this.translateItem(index, this.currIndex);
        const img = this.$refs[`img${index}`][0];
        img.style.zIndex = this.getZIndex(index);
        img.style.transition = `all ${this.animationInterval / 1000}s`;
        img.style.transform = 'translateX(' + translate + 'px)';
      });
    },

    getZIndex(i) {
      if (i == this.currIndex) {
        return this.datas.length
      }
      if (this.currIndex == 0 && i == this.datas.length - 1) {
        // 第一个 要处理一下最后一个
        if (this.currIndex > this.oldCurrentIndex) {
          return 1
        }
        return 2
      } else if (this.currIndex == this.datas.length - 1 && i == 0) {
        // 最后一个 要处理一下第一个
        return 2
      }
      let isInStage = Math.round(Math.abs(i - this.currIndex)) <= 1;
      if (isInStage) {
        return 2
      }
      return 1
    },

    translateItem(index, currentIndex) {
      const isInStage = Math.round(Math.abs(index - currentIndex)) <= 2;
      return this.calcCardTranslate(isInStage, index, currentIndex);
    },

    calcCardTranslate(indexInStage, index, activeIndex) {
      const parentWidth = this.$parent.$el.offsetWidth;
      if (activeIndex == 0 && index == this.datas.length - 1) {
        // 第一个 要处理一下最后一个
        return -7.92 * this.rem;
      } else if (activeIndex == this.datas.length - 1 && index == 0) {
        // 最后一个 要处理一下第一个
        return 9.72 * this.rem;
      } else if ((activeIndex == this.datas.length - 2 && index == 0) || (activeIndex == this.datas.length - 1 && index == 1)) {
        return 18.54 * this.rem;
      }

      if (indexInStage) {
        return (index - activeIndex) * (8.58 + 0.24) * this.rem + 0.66 * this.rem + 0.24 * this.rem;
      }  else if (index < activeIndex) {
        return - 8.58 * this.rem;
      } else {
        return parentWidth;
      }
    },
    /**
     轮播滑动清空
     @param
     @return
     */
    transClear() {
      this.transing = false;
    },
    /**
     获取上一个序号
     @param {Number} i 序号
     @return {Number} 上一个序号
     */
    getPrevIndex(i) {
      if (i == 0) {
        return this.datas.length - 1;
      }
      return i - 1;
    },
    /**
     获取下一个序号
     @param {Number} i 序号
     @return {Number} 下一个序号
     */
    getNextIndex(i) {
      if (i == this.datas.length - 1) {
        return 0;
      }
      return i + 1;
    },
    /**
     获取图片class
     @param {Number} i 序号
     @return {String} 图片class
     */
    getImgClass(i) {
      if (i == this.currIndex) {
        return 'curr';
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
.swiper {
  position: relative;
  height: 100%;
  overflow: hidden;

  > .swiper-item {
    position: absolute;
    top: 0;
    left: 0;
    width: 8.58rem;
    height: 6.42rem;
    overflow: hidden;

    > img {
      width: 100%;
      height: 100%;
      transition: all 0.4s;
      object-fit: cover;
    }
  }
}

.swiper-prev {
  position: absolute;
  top: 50%;
  left: 1.14rem;
  transform: translateY(-50%);
  z-index: 99;
  width: 0.6rem;
  height: 0.6rem;
  background: url("../img/swiper-left.png") no-repeat center center;
  background-size: 100% 100%;
  cursor: pointer;

  &:hover {
    background: url("../img/swiper-left-hover.png") no-repeat center center;
    background-size: 100% 100%;
  }
}

.swiper-next {
  position: absolute;
  top: 50%;
  right: 1.14rem;
  transform: translateY(-50%);
  z-index: 99;
  width: 0.6rem;
  height: 0.6rem;
  background: url("../img/swiper-right.png") no-repeat center center;
  background-size: 100% 100%;
  cursor: pointer;

  &:hover {
    background: url("../img/swiper-right-hover.png") no-repeat center center;
    background-size: 100% 100%;
  }
}
</style>
